import { render, staticRenderFns } from "./ClientOrders.vue?vue&type=template&id=58efe892&scoped=true"
import script from "./ClientOrders.vue?vue&type=script&lang=js"
export * from "./ClientOrders.vue?vue&type=script&lang=js"
import style0 from "./ClientOrders.vue?vue&type=style&index=0&id=58efe892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58efe892",
  null
  
)

export default component.exports